export class FormatterHelper {
    static roundNumber2Decimals(number): string {
        return (Math.round(number * 100) / 100).toFixed(2);
    }

    static changeDecimalSeparator(number): number {
        return number.replace('.', ',');
    }

    static germanDateFormatter(date): string {
        let formattedDate = new Date(date);
        const options = {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: 'numeric',
            minute: '2-digit',
        };

        let formattedDateString = formattedDate.toLocaleString('de-DE', options);
        formattedDateString = formattedDateString.replace(/\,/g, '');
        return formattedDateString;
    }

    static extractHourToDate(date): string {
        let formattedDate = this.germanDateFormatter(date);
        formattedDate = formattedDate.slice(0, formattedDate.length - 6);
        return formattedDate;
    }

    static extractDateToDate(date): string {
        let formattedDate = this.germanDateFormatter(date);
        formattedDate = formattedDate.slice(10, formattedDate.length);
        return formattedDate;
    }

    static capitalizeFirstLetter(string) {
        if (string !== null) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
        return 'AnspName';
    }

    static stringToList(data: string): string[] {
        var separators = [',', ';'];
        data = data.replace(' ', '');
        return data.split(new RegExp(separators.join('|'), 'g'));
    }
}